import styled from 'styled-components';

const PostsForm = styled.form`
  display: block;
  margin-top: 0em;
`;

export default PostsForm;
